<template>
  <Sidebar>
    <div class="pb-4 padding-trasition px-4">
      <div class="d-flex justify-start">
        <BackBtn :title="$t('Back_to_meeting')" :parent="meeting" :subtitle="toLocaleDateTimeString(meeting.start)" />
        <AgendaItemsNavigationSwitcher v-if="meeting.has_tagesordnung" v-model="activeNavigation" :meeting="meeting" />
      </div>
    </div>
    <AgendaItemList
      v-if="!meeting.has_tagesordnung || activeNavigation === 'agenda_item_list'"
      :scroll-to="scrollTo"
      :items="agendaitems"
      :empty-message="$t('no_agenda_items_existing')"
    >
      <template slot="top">
        <v-divider v-if="agendaitems.length" />
      </template>
    </AgendaItemList>
    <TagesordnungList
      v-else-if="activeNavigation === 'tagesordnung_list'"
      :meeting="meeting"
      switcher="select"
      compact
    />
  </Sidebar>
</template>
<script>
import AgendaItem from '@/store/models/agendaitem'
import mixin from '@/components/sidebars/mixin'
import { toLocaleDateTimeString } from '@/filters'

export default {
  name: 'AgendaItemsSidebar',
  mixins: [mixin],
  props: {
    scrollTo: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      activeNavigation: null,
      currentItem: null,
    }
  },
  computed: {
    isBusinessDirectoryActive() {
      return !this.$route.query.tagesordnungitem_id
    },
    agendaItem() {
      return AgendaItem.query().with('meeting.agendaitems').find(this.$store.state.route.params.id)
    },
    meeting() {
      return AgendaItem.query().with('meeting').find(this.$route.params.id).meeting
    },
    agendaitems() {
      return AgendaItem.query()
        .with('notes')
        .with('attachments.annotations')
        .with('proposal')
        .with('proposal.annotations')
        .where('meeting_id', this.agendaItem.meeting_id)
        .orderBy('sort_order')
        .all()
    },
  },
  methods: {
    toLocaleDateTimeString,
  },
}
</script>
